import { GenericApi } from './generic.api';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBlogCategory } from '../model/ddb.model';
import { Observable } from 'rxjs';
import { IBlog } from '../model/blog.model';
import { IQueryFilter, QueryResult } from '../model/query.filter.class';
import { createUrl, queryToParams, getPublicRoutesHeaders } from './api.util';

type T = IBlogCategory;

@Injectable()
export class BlogCategoryApi extends GenericApi<T> {
  public path = "blog-category";

  constructor(
    public httpClient: HttpClient
  ) {
    super(httpClient);
  }
  	readonly webList = (): Observable<IBlogCategory[]> => {
		return this.httpClient.get<IBlogCategory[]>(
			createUrl(this.path, "web", "list"),
			{
				headers: getPublicRoutesHeaders(),
			}
		);
	};
}
